/* list-item.tsx generated by @compiled/babel-plugin v0.32.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
function _ListItem(_ref, ref) {
  var children = _ref.children,
    xcss = _ref.xcss;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    React.createElement("div", {
      role: "listitem",
      ref: ref,
      className: xcss
    }, children)
  );
}

/**
 * __List item__
 *
 * An element with the role of `listitem`.
 */
export var ListItem = /*#__PURE__*/forwardRef(_ListItem);